module.exports = __webpack_public_path__ + "static/media/cp3.7298a299.jpg";